
<div class="card profile-eduction " *ngIf="ShowList">
  <div class="card-body padding-tb padding-right margin-left-zero">

    <div class="row">
      <div class="col-md-12 padding-all-0px margin-left-zero">
        <!--<h6 class="panel-title fb">Education Info</h6>-->
        <div class="table-component">
          <div class="table-responsive">
            <table class="table  profile-table margin-left-zero">
              <!--<thead class="profile-thead ">
                <tr>
                  <th scope="col">Location</th>
                  <th scope="col"> Remarks</th>

                  <th scope="col"></th>

                </tr>
              </thead>-->
              <tbody>
                <tr *ngFor="let l of CurrentActorSpecialtyInfoController">
                  <td>
                    <div class="row margin-left-zero">
                      <label class="font-size-14px margin-bottom-0px"> {{l.PreferenceTypeLongValue}}</label>
                    </div>
                    <div class="row margin-left-zero">
                      <label class="font-size-11px margin-bottom-0px">{{l.Remarks}}</label>
                    </div>
                    </td>
                    
                  

                  <td>
                    <div class="row">
                      <a (click)="edit_(l)" class="nav-link-hand education-navlink margin-left-auto " *ngIf="CanEdit === 1 ">
                        <span class="badge"><i class="fas fa-pencil-alt color-edit-icon"></i></span>
                      </a>
                      <a (click)="del2_(l)" class="nav-link-hand education-navlink color-delete-icon " *ngIf="CanEdit === 1 ">
                        <span class="badge">
                          <i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
    
  </div>

    
    <div *ngIf='IsExpand'>
      <div class="row" *ngIf="ShowList">
        <div class="col-md-12 col-xs-12 mt-2 mb-4 text-right add-but addnew">
          <button type="button" (click)="clearData()" class="btn btn-primary btn-sm margin-right-39px"><!--<i class="fas fa-plus nav-link-hand"> </i>--> Add New</button>
        </div>
      </div>
      <div *ngIf='isNew && !ShowList'>
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

          <div class="comon-box profile-box p-0 margin-left-18px">
            <h4 class="heading-pinkbg mt-0">Add Location</h4>
            <div class="row pl-3 pr-3 margin-left-zero">


              <div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2">Location</label>
                <CodeTypeValue CodeType="STATE" id="CurrentActorSpecialtyRequest.Preference"
                               [(ngModel)]="CurrentActorSpecialtyRequest.Preference"
                               [SelectedValue]="CurrentActorSpecialtyRequest.Preference"
                               name="CurrentActorSpecialtyRequest.Preference" #Location="ngModel"></CodeTypeValue>

              </div>

              <div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2">Remarks</label>
                <input type="text" class="form-control" id="CurrentActorSpecialtyRequest.Remarks"
                       [(ngModel)]="CurrentActorSpecialtyRequest.Remarks" 
                       name="CurrentActorSpecialtyRequest.DurationY" placeholder="Remarks" maxlength="50" #DurationY="ngModel">
                
              </div>


           


              <br /><br /><br /><br /><br />

            </div>


          </div>
          
          <div class="row margin-right" *ngIf="CanEdit === 1 ">
            <div class="card-footer text-right col-12">
              <button (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3">Cancel</button>
              <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Save</button>




            </div>
          </div>

        </form>
      </div>
      <div *ngIf='isEdit && !ShowList'>
        <form class="form" novalidate="" #f="ngForm">
          <!--(ngSubmit)="onEditSubmit()"-->

          <div class="comon-box p-0 margin-left-zero margin-left-18px">
            <h4 class="heading-pinkbg mt-0">Update Location</h4>
            <div class="row pl-3 pr-3 margin-left-zero">






              <div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2">Location</label>
                <!--<CodeTypeValue CodeType="STATE" id="CurrentActorEditSpecialtyInfoRequest.Preference"
                               [(ngModel)]="CurrentActorEditSpecialtyInfoRequest.Preference"
                               [SelectedValue]="CurrentActorEditSpecialtyInfoRequest.Preference"
                               name="CurrentActorEditSpecialtyInfoRequest.Preference"
                               #Location="ngModel"></CodeTypeValue>-->
                <label class="font-weight-bold data-color-new">{{CurrentActorEditSpecialtyInfoRequest.Preference}}</label>

              </div>

              <div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2">Remarks</label>
                <input type="text" class="form-control" id="CurrentActorEditSpecialtyInfoRequest.Remarks"
                       [(ngModel)]="CurrentActorEditSpecialtyInfoRequest.Remarks"
                       name="CurrentActorEditSpecialtyInfoRequest.Remarks" placeholder="Remarks" maxlength="100" #Remarks="ngModel">

              </div>



              <br /> <br /><br /><br /><br />
            </div>


          </div>


          <div class="row margin-right" *ngIf="CanEdit === 1 ">
            <div class="card-footer text-right col-12">

              <button (click)="CancelUpdateOperation()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand actions-btn-prime3">Cancel</button>
              <button (click)="onEditSubmit()" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Update</button>


            </div>
          </div>




        </form>
      </div>
    </div>


   
